import React, { useState, useEffect } from 'react'
import { ThemeProvider } from '@emotion/react'
import SearchProvider from 'components/search/provider'
import AppContext from 'context/app'
import Nav from 'components/nav'
import Footer from 'components/footer'
import * as styles from 'styles/exports.module.scss'

export default function Layout({ children }) {
    const [clientWidth, setClientWidth] = useState(typeof document !== `undefined` ? document.body.clientWidth : null) // excludes scrollbar width
    const [screenWidth, setScreenWidth] = useState(typeof window !== `undefined` ? window.screen.width : null) // includes scrollbar width
    const [screenHeight, setScreenHeight] = useState(typeof window !== `undefined` ? window.screen.height : null)
    const [overlay, setOverlay] = useState('')
    const [subMenu, setSubmenu] = useState('')

    const closeOverlay = () => {
        if(overlay === 'Mobile') setOverlay('')
        else setTimeout(() => setOverlay(''), 300)
    }
    
    useEffect(() => {
        if(typeof window === 'undefined') return

        const handleResize = e => {
            setClientWidth(e.target.document.body.clientWidth)
            setScreenWidth(e.target.screen.width)
            setScreenHeight(e.target.screen.height)
        }
        
        window.addEventListener('resize', handleResize)
        
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    
    useEffect(() => {
        if(typeof document === 'undefined') return

        const handleCloseOverlay = ({ target }) => {
            if(!overlay) return

            const mainOverlay = target.closest('#main-overlay')
            const mobileOverlay = target.closest('#mobile-overlay')
            
            const input = target.closest('input')
            const button = target.closest('button')
            const img = target.closest('img')

            if(input || button || img) return
            if(!mainOverlay && !mobileOverlay) closeOverlay()
        }

        const handleKeydown = ({ key }) => {
            if(!overlay) return
            if (key === 'Escape') closeOverlay()
        }
        
        document.addEventListener('click', handleCloseOverlay)
        document.addEventListener('keydown', handleKeydown)

        if(!overlay) setSubmenu('')
        
        return () => {
            document.removeEventListener('click', handleCloseOverlay)
            document.removeEventListener('keydown', handleKeydown)
        }
    }, [overlay])

    const value = {
        clientWidth,
        screenWidth,
        screenHeight,
        overlay, setOverlay,
        subMenu, setSubmenu,
        closeOverlay,
    }

    // https://emotion.sh/docs/theming
    const theme = {
        fonts: {
            primary: styles.primaryFont,
            primaryCompressed: styles.primaryFontCompressed,
            secondary: styles.secondaryFont,
            tertiary: styles.tertiaryFont,
        },
        colors: {
            primary: styles.primaryColor,
            gray: styles.gray,
            black: styles.black,
        },
    }
    
    return (
        <AppContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                <SearchProvider>
                    <Nav zIndex={3} />
                </SearchProvider>
                <SearchProvider>
                    <main style={{ zIndex: 2 }}>{children}</main>
                </SearchProvider>
                <Footer />
            </ThemeProvider>
        </AppContext.Provider>
    )
}
